/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfig extends models.ServiceNowCmdbConfigBaseResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfig.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfig>): ServiceNowCmdbConfig {
        let obj = Object.assign(new ServiceNowCmdbConfig(), model);
        ServiceNowCmdbConfig.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfig>): ServiceNowCmdbConfig {
        if (!model) return null;
        return ServiceNowCmdbConfig.newInstance(<ServiceNowCmdbConfig> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfig) {
        if (!obj) return;

        models.ServiceNowCmdbConfig.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfig): boolean {
        if (models.ServiceNowCmdbConfigBaseResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfig.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * When the configuration was created
     */
    created_at: string;

    /**
     * When the configuration was updated
     */
    updated_at: string;

    /**
     * Name of the user who created this configuration
     */
    created_by: string;

    /**
     * Name of the user who updated this configuration
     */
    updated_by: string;

}
